<template>
  <div class="store-slide">
    <div class="store-content">
      <div
        ref="slickWrap"
        class="list-images"
      >
        <VueSlickCarousel
          v-if="storySlideRef && storySlideRef.StoryBanner"
          :arrows="true"
          :dots="false"
          :slides-to-show="2"
          :variable-width="true"
          :responsive="[
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ]"
        >
          <div
            v-for="(story, sIndex) in storySlideRef.StoryBanner"
            :key="'story-carousel-' + sIndex"
          >
            <div class="slide_item">
              <SfImage
                ref="infoImage"
                :src="story.image"
                class="calImage"
                alt="Image"
                width="140"
                height="140"
              />
              <h2 class="heading">
                {{ story.heading }}
              </h2>
              <span>{{ story.content }}</span>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>
<script>
import { SfImage } from '@storefront-ui/vue';
import { contentGetters, useContent } from '@vue-storefront/gemini';
import { computed, ref, defineComponent } from '@nuxtjs/composition-api';
import VueSlickCarousel from 'vue-slick-carousel';
import { useI18n } from '../helpers/hooks/usei18n';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default defineComponent({
  name: 'StorySlide',
  components: {
    SfImage,
    VueSlickCarousel,
  },

  setup() {
    const { locale } = useI18n();
    const { blocks } = useContent(`cmsBlockFooter-${locale}`);
    const loading = ref(true);

    const identifierStorySlide = `storySlide-${locale}`;
    const storySlideRef = ref(false);
    const storySlide = computed(() => contentGetters.getCmsBlockContent(blocks.value)).value[identifierStorySlide];

    return {
      storySlide,
      storySlideRef,
      identifierStorySlide,
      loading,
    };
  },
  data() {
    return {
      imageHeight: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.storySlideRef = this.storySlide;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      window.addEventListener('resize', this.handleMatchCenterArrows);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      window.addEventListener('load', this.handleMatchCenterArrows);
    });
  },
  beforeDestroy() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    window.removeEventListener('resize', this.handleMatchCenterArrows);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    window.removeEventListener('load', this.handleMatchCenterArrows);
  },
  methods: {
    handleMatchCenterArrows() {
      this.imageHeight = this.$refs.infoImage.$el.clientWidth;
      const parentEl = this.$refs.slickWrap;
      const elArrows = parentEl.querySelectorAll('.slick-arrow');
      for (let i = 0; i <= elArrows.length; i += 1) {
        if (elArrows[i]) {
          elArrows[i].style.top = `${this.imageHeight / 2}px`;
        }
      }
    },
  },
});
</script>

<style lang="scss">
.store-slide {
  .slick-arrow {
    top: 38%;
  }

  .slick-prev,
  .slick-next {
    z-index: 1;

    .sf-icon {
      height: 47px;
      width: 33px;
    }

    &:before {
      display: none;
    }
  }

  .slick-prev,
  .slick-next {
    height: auto;
    width: auto;

    &:after {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      content: '';
      display: block;
      height: 45px;
      width: 45px;
    }
  }

  .slick-prev {
    left: 15px;

    &:after {
      background-image: url('https://cdn.lazzarionline.com/626fda63dac21c9b7d38edd8.svg');
    }
  }

  .slick-next {
    right: 15px;

    &:after {
      background-image: url('https://cdn.lazzarionline.com/626fda63dac21c9b7d38edd8.svg');
      transform: rotate(180deg);
    }
  }

  .image-wrap {
    display: block !important;

    img {
      display: block;
      min-height: 247px;
      object-fit: cover;
      object-position: center;
      width: 100%;
    }
  }

  .store-content {
    position: relative;

    .list-images {
      bottom: 0;
      height: 100%;
      left: 0;
      right: 0;
      top: 0;
      width: 100%;
    }
    .slick-slider,
    .slick-list,
    .slick-track,
    .slick-slide * {
      height: 100%;
    }
  }
}

#story_container .sf-carousel__controls .sf-arrow.sf-button:before {
  display: block;
  font-size: 25px;
  line-height: 30px;
  position: relative;
  z-index: 2;
}

#story_layout {
  .store-content {
    padding: 0 24px 92px 10.5px;
    max-width: 1414px;
    margin: 0 auto;
  }

  .slide_item {
    padding: 0 13.5px;
    max-width: 596px;
    .sf-image--wrapper {
      display: block;
    }
    .sf-image {
      display: block;
      width: 100%;
      height: auto;
      position: unset;
      opacity: 1;
    }
    h2 {
      color: #222a24;
      font-size: 32px;
      line-height: 43px;
      margin: 30px 0 4px;
    }
    span {
      font-size: 14px;
      line-height: 23px;
      color: #5e6770;
      min-height: 79px;
      font-family: 'Spartan';
      font-weight: 500;
    }
  }

  .slick-slider .slick-track {
    display: flex;
  }
  .slick-prev,
  .slick-next {
    width: auto;
    height: auto;
    &:before {
      content: '';
      opacity: 1;
      color: #222a24;
      font-size: 25px;
    }
  }
}

@media (max-width: 1023px) {
  .store-slide {
    .slick-arrow {
      top: 35%;
    }
  }
}

@media (max-width: 911px) {
  .store-slide {
    .slick-arrow {
      top: 30%;
    }
  }
}

@media (max-width: 768px) {
  .store-slide {
    .slick-arrow {
      top: 38%;
    }
  }

  .sf-carousel .slide_item {
    padding: 0 5px;
  }
  #story_container {
    .sf-carousel {
      padding: 0 19px 63px;
    }
  }

  .story_slick {
    padding-bottom: 68px;

    .slide_item {
      min-width: 328px;
      max-width: 328px;
      padding: 0 5px;
      h2 {
        font-size: 28px;
        line-height: 36px;
        margin: 28px 0 8px;
      }
      span {
        font-size: 12px;
        line-height: 20px;
      }
    }
  }

  #story_layout .store-content {
    padding: 0 19px;
  }
}

@media (max-width: 540px) {
  .store-slide .slick-arrow {
    top: 36%;
  }
}

@media (max-width: 460px) {
  .store-slide .slick-arrow {
    top: 33%;
  }
}
</style>
